<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
        <v-card :loading="loading">
            <v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-container>
                <v-data-table locale="pt-BR" 
                                dense fixed-header 
                                class="table-item" 
                                :items="publicacoes" 
                                :headers="fields" 
                                :items-per-page="15">

                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon color="primary" @click="ler(item)">
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                                <v-btn v-on="on" icon color="primary" @click="aprovar(item)">
                                    <v-icon>mdi-check</v-icon>
                                </v-btn>
                            </template>
                            <span>Aprovar</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon color="primary"  @click="inativar(item)">
                                    <v-icon>mdi-eye-off</v-icon>
                                </v-btn>
                            </template>
                            <span>inativar</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
                </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
        </v-card>
    </v-dialog> 
</template>

<script>
import Br from '@/config/barramento.js'
import axios from 'axios'
import { baseApiUrl, showSuccess, showError } from "@/config/global"


export default {
    data(){
        return{
            publicacoes: [],
            fields: [
					{value: 'nome', text: 'Nome'},
					{value: 'data', text: 'Data'},
					{value: 'grau', text: 'Grau'},
					{value: 'autor', text: 'Autor'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
                ],
            mostrar: false,
            loading: false,
            cor: 'primary',
        }
    },
    methods:{
        aprovar(item){
            this.loading = true
            const url = `${baseApiUrl}/estudos/aprovar.php` 
            //const urlEmail = `${baseApiUrl}/emails/publicacaoAprovada.php`

            axios.post(url, item).then(res => {
                
                if(res.data.codigo == '01'){

                    //axios.post(urlEmail, item)

                    this.loading = false
                    showSuccess(res.data.mensagem)
                    this.atualizarRegistro(item, 'A')

                }else{
                    this.loading = false
                    showError(res.data.mensagem)
                }
                
            })
        },

        ler(item){
            Br.setLerPublicacao(item)
        },

        inativar(item){
            this.loading = true
            const url = `${baseApiUrl}/estudos/inativar.php` 
				
            axios.post(url, item).then(res => {
                
                if(res.data.codigo == '01'){
                    this.loading = false
                    showSuccess(res.data.mensagem)
                    this.atualizarRegistro(item, 'I')
                }else{
                    this.loading = false
                    showError(res.data.mensagem)
                }
                
            })
        },

        atualizarRegistro(item, destino){

            let idx = this.publicacoes.findIndex((v) => {
                return v.id == item.id
            })
            item.statusAtual = 'R'
            if(destino == "A"){
                Br.setPublicacaoAprovada(item)
            }else if(destino == "I"){
                Br.setPublicacaoInativada(item)
            }
            this.publicacoes.splice(idx, 1)
            if(this.publicacoes.length == 0){
                showSuccess("Não há mais publicações reprovadas!")
                this.fechar()
            }
        },

        fechar(){
            this.mostrar = false
        }
    },

    created(){
        Br.onAbrirPublicacoesReprovadas(publicacoes => {
            this.publicacoes = publicacoes
            this.mostrar = true
        })
    }
}
</script>